import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import { DialogData } from '../confirmation-dialog/dialog-data';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface Report {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'anms-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportDialogComponent implements OnInit {
  dialogData: DialogData;
  reports: Report[] = [
    { value: 'not-interested', viewValue: 'Not Interested' },
    { value: 'spam', viewValue: 'Spam' },
    { value: 'abusive-harmful', viewValue: 'Abusive/Harmful' },
    { value: 'hate-speech', viewValue: 'Hate Speech' },
    { value: 'nudity', viewValue: 'Nudity' },
    { value: 'other', viewValue: 'Other' }
  ];
  constructor(
    public matDialogRef: MatDialogRef<ReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    if (data) this.dialogData = data;
  }

  ngOnInit(): void {}

  closeWithYes(): void {
    this.matDialogRef.close('yes');
  }
}
